export default __webpack_public_path__ + "static/CEO Illustration-20f470d60474afc7bb64732628b12641.png";